import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { VoucherContainer } from './VoucherInput.styles';

const VoucherInput = forwardRef(
  (
    {
      className,
      name,
      onChange,
      placeholder,
      dataCy = 'voucher-input',
      dataTestId = 'voucher-input',
      value,
      defaultValue,
      isControlled = true,
      message,
      type,
      inline
    },
    ref
  ) => {
    const handleChange = (event) => onChange && onChange(event);

    const inputProps = isControlled ? { value } : { defaultValue, ref };

    return (
      <VoucherContainer inline={inline} className={className} data-cy={`${dataCy}-container`}>
        <span>{message}</span>
        <input
          {...inputProps}
          data-cy={dataCy}
          data-testid={dataTestId}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          type={type}
        />
      </VoucherContainer>
    );
  }
);

VoucherInput.displayName = 'VoucherInput';

VoucherInput.propTypes = {
  className: PropTypes.string,
  isControlled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataCy: PropTypes.string,
  dataTestId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  inline: PropTypes.bool
};

export default VoucherInput;
